import React from 'react';
import PropdocsModal from '../../../../modal/PropdocsModal';
import Button from 'react-bootstrap/Button';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import styles from './mobileSigningPrepWarningModal.module.scss';

interface MobileSigningPrepWarningModalProps {
  show: boolean;
  onGoBack: () => void;
  onContinue: () => void;
}

const MobileSigningPrepWarningModal = ({
  show,
  onGoBack,
  onContinue,
}: MobileSigningPrepWarningModalProps) => {
  const classes = classNames(
    styles['mobileSigningPrepWarningModal'],
    'document-wizard-modal-custom'
  );

  return (
    <PropdocsModal
      show={show}
      setShow={() => {}} // No close button, user must choose an option
      size="md"
      className={classes}
      disableClose={true}
      title={
        <header className={styles.modalHeader}>
          <FormattedMessage 
            id="title.mobile-signing-prep-warning" 
            defaultMessage="Desktop View Recommended" 
          />
        </header>
      }
    >
      <div className={styles.modalContent}>
        <div className={styles.warningMessage}>
          <p>
            <FormattedMessage
              id="message.mobile-signing-prep-warning-1"
              defaultMessage="This page is optimized for tablet and desktop viewing."
            />
          </p>
          <p>
            <FormattedMessage
              id="message.mobile-signing-prep-warning-2"
              defaultMessage="The signing preparation tools work best on larger screens where you can easily drag and drop signature fields."
            />
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            onClick={onGoBack}
            variant="primary"
            className={styles.primaryButton}
          >
            <FormattedMessage
              id="cta.go-back-to-deal"
              defaultMessage="Go Back to Deal"
            />
          </Button>
          <Button
            onClick={onContinue}
            variant="secondary"
            className={styles.secondaryButton}
          >
            <FormattedMessage
              id="cta.continue-anyway"
              defaultMessage="Continue Anyway"
            />
          </Button>
        </div>
      </div>
    </PropdocsModal>
  );
};

export default MobileSigningPrepWarningModal;